import { useHistory, useLocation } from 'react-router-dom'
import { useFilmTrailerPlaylistQuery } from '@mwxltd/flix-api-client'
import LoadingGrid from '../../../components/layout/Loading/LoadingGrid'
import { useTrailerSeekTime } from '../../../components/video/TrailerSeekTimeProvider/TrailerSeekTimeProvider'
import VideoPlayer from '../../../components/video/VideoPlayer/VideoPlayer'
import ErrorPage from '../../../containers/errors/ErrorPage/ErrorPage'
import { onFilmPlayerClose } from '../onFilmPlayerClose'

const TrailerPlayerPage = ({ filmSlug }) => {
  const history = useHistory()
  const location = useLocation()

  const { initialSeekTime, captureSeekTime } = useTrailerSeekTime(filmSlug)

  const { loading, error, data, nextVideoStarted } = useFilmTrailerPlaylistQuery(
    filmSlug,
    initialSeekTime,
  )

  if (loading) {
    return <LoadingGrid />
  }
  if (error) {
    return <ErrorPage error={error} />
  }

  return (
    <VideoPlayer
      filmSlug={filmSlug}
      filmId={data?.film?.id}
      playlist={data?.playlist ?? []}
      onProgress={captureSeekTime}
      onNextVideo={nextVideoStarted}
      onRequestClose={onFilmPlayerClose(filmSlug, history, location)}
      errorMetadata={{ film: { slug: filmSlug } }}
      bigPlayButton
    />
  )
}

export default TrailerPlayerPage
